module.exports = __webpack_public_path__ + "img/4.3f259524.png";